import { createStore } from "redux";
import mergeReducers from "../reducers/utils";
import rootReducer from "../reducers/index"; // CORE
import customReducers from '../components/library/custom/-APP_TARGET/CustomReducers'; // CUSTOM PROJECT

const reducers = mergeReducers([rootReducer, ...customReducers]);
const store = createStore(reducers);

export default store;
